
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"clip-rule":"evenodd","d":"M11.003 7.644C11.191 7.25 11.577 7 12 7c.423 0 .81.25.997.644l.684 1.442c.162.341.475.578.837.632l1.53.231c.419.064.767.368.898.787.13.418.021.877-.281 1.184l-1.108 1.123a1.184 1.184 0 00-.32 1.022l.262 1.584c.071.434-.1.872-.442 1.13a1.076 1.076 0 01-1.17.088l-1.37-.748a1.074 1.074 0 00-1.034 0l-1.37.748c-.374.205-.827.17-1.17-.088a1.177 1.177 0 01-.442-1.13l.262-1.584a1.184 1.184 0 00-.32-1.022L7.335 11.92a1.187 1.187 0 01-.28-1.184c.13-.419.478-.723.897-.787l1.53-.23c.362-.055.675-.292.837-.633l.684-1.442z","stroke":"currentColor","stroke-width":"1.5","stroke-linecap":"round","stroke-linejoin":"round"}})])
          )
        }
      }
    